angular.module('impactx.search').component('ixCatalogItemActions', {
        bindings: {
            catalog: '<'
        },
        controller: 'CatalogItemActionCtrl',
        controllerAs: 'actionsCtrl',
        templateUrl: 'modules/search/templates/catalog-item-actions.html'
    }
);